export enum RouteNames {
  ModifyId = 'ModifyId',
  TokenDate = 'TokenDateView',
  FormFulfilled = 'FormFulfiled',
  Event = 'EventView',
}

export enum RoutePaths {
  ModifyId = ':id',
  TokenDate = 'token-date',
  FormFulfilled = 'form-fulfiled',
  Event = 'event',
}
